import type { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';

/** Body of `POST /api/search/insights/outcomes`. */
export type SearchOutcome = {
  sid: string;
  outcome: 'select' | 'abandon';
  rank?: number;
  resultType?: string;
  resultCount?: number;
  surface: string;
};

/**
 * Sends a search outcome to the backend search query log. Fire-and-forget:
 * it never throws or blocks the caller. The request uses `keepalive` so it
 * survives the navigation a result click starts, and failures are ignored
 * because outcome tracking must never affect the UI.
 */
export function sendSearchOutcome(
  apis: { discoveryApi: DiscoveryApi; fetchApi: FetchApi },
  outcome: SearchOutcome,
): void {
  apis.discoveryApi
    .getBaseUrl('search')
    .then(baseUrl =>
      apis.fetchApi.fetch(`${baseUrl}/insights/outcomes`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(outcome),
        keepalive: true,
      }),
    )
    .catch(() => {});
}
